export * from '@fhs/routing/src/routes/(drawer)/support/_layout';
export { default } from '@fhs/routing/src/routes/(drawer)/support/_layout';
